<template>
  <div>
    <p>lang: {{ lang }}</p>
    <p>timezone: {{ timezone }}</p>
    <p>storageUser: {{ storageUser }}</p>
    <p>storageHistory: {{ storageHistory }}</p>
    <p>storageLocale:{{ storageLocale }}</p>
  </div>
</template>
<script>
export default {
  name: 'DebugView',
  data: function () {
    return {
      lang: '',
      timezone: '',
      storageUser: '',
      storageHistory: '',
      storageLocale: '',
    }
  },
  mounted: function () {
    this.lang = navigator.language || navigator.userLanguage
    this.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
    this.storageUser = window.localStorage.getItem('user')
    this.storageHistory = window.localStorage.getItem('history')
    this.storageLocale = window.localStorage.getItem('locale')
  },
}
</script>
<style scoped>
p {
  word-wrap: break-word;
}
</style>
